import { Box, Typography } from '@mui/material';
import { t } from 'i18next';
import ParkingDashboard from 'images/ParkingDash.png';
export default function ParkingDetails() {
  return (
    <Box px={2} py={2}>
      <Typography variant='h5' align='center' mb={2}>{t('parkingdashboardText', { ns: ['home'] })}</Typography>
      <img src={ParkingDashboard} style={{ width: '100vw' }} />
    </Box>
  );
}
